export enum shortcutType {
  addRow = "ADD_ROW",
  deleteRow = "DELETE_ROW",
  cut = "CUT",
  copy = "COPY",
  paste = "PASTE",
  moveLeft = "MOVE_LEFT",
  moveRight = "MOVE_RIGHT",
}

export const shortcutsObj = {
  [shortcutType.addRow]: {
    action: "Insert row above",
    shortcut: ["Ctrl", "Shift", "+"],
  },
  [shortcutType.deleteRow]: {
    action: "Delete row",
    shortcut: ["Ctrl", "-"],
  },
  [shortcutType.cut]: {
    action: "Cut",
    shortcut: ["Ctrl", "X"],
  },
  [shortcutType.copy]: {
    action: "Copy",
    shortcut: ["Ctrl", "C"],
  },
  [shortcutType.paste]: {
    action: "Paste",
    shortcut: ["Ctrl", "V"],
  },
  [shortcutType.moveLeft]: {
    action: "Move to the left cell",
    shortcut: ["Shift", "Tab"],
  },
  [shortcutType.moveRight]: {
    action: "Move to the right cell",
    shortcut: ["Tab"],
  },
};
